import { render, staticRenderFns } from "./createTicketType.vue?vue&type=template&id=9ec933da&scoped=true"
import script from "./createTicketType.vue?vue&type=script&lang=js"
export * from "./createTicketType.vue?vue&type=script&lang=js"
import style0 from "./createTicketType.vue?vue&type=style&index=0&id=9ec933da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec933da",
  null
  
)

export default component.exports